import { memo } from 'react'

import { copy } from '~/modules/lunya'
import { useHaptic } from '~/shared/platform'
import { Button, HStack, Text } from '~/shared/ui'

import { GENDER_LABELS, GENDER_ORDER } from './config'
import type { GenderChipsProps } from './types'

import styles from './GenderChips.module.scss'

/**
 * Вопрос «Ты у нас…?» + две кнопки Ж/М во всю ширину, высота 46-50 (спека 02 §A1·2).
 * Показывается только когда `guessGenderByName` не смог определить пол уверенно.
 */
export const GenderChips = memo(function GenderChips(props: GenderChipsProps) {
  const { value, onChange } = props
  const haptic = useHaptic()

  const handlePress = (gender: (typeof GENDER_ORDER)[number]) => {
    haptic.selection()
    onChange(gender)
  }

  return (
    <div className={styles.root}>
      <Text variant='CAPTION' color='ACCENT_SOFT'>
        {copy.onb.a1.gender_q}
      </Text>
      <HStack gap='SMALL_M'>
        {GENDER_ORDER.map((gender) => (
          <div key={gender} className={styles.chip}>
            <Button
              variant={value === gender ? 'PRIMARY' : 'SECONDARY'}
              width='FULL'
              text={GENDER_LABELS[gender]}
              onPress={() => handlePress(gender)}
            />
          </div>
        ))}
      </HStack>
    </div>
  )
})
